var React = require('react');

function Home (props) {
    return React.createElement("svg",props,React.createElement("g",{"id":"home-3--home-house-roof-shelter"},[React.createElement("path",{"id":"Intersect","stroke":"currentColor","strokeLinecap":"round","strokeLinejoin":"round","d":"M.834 11.182.782 7.106C2.363 4.523 3.653 3.043 6.45 1.12a.97.97 0 0 1 1.1 0c2.797 1.922 4.087 3.402 5.668 5.985l-.051 4.076a2.08 2.08 0 0 1-1.824 1.826 39.175 39.175 0 0 1-8.686 0 2.08 2.08 0 0 1-1.823-1.826Z","key":0}),React.createElement("path",{"id":"Vector (Stroke)","stroke":"currentColor","strokeLinecap":"round","strokeLinejoin":"round","d":"M8.667 13.218V9.757a1.668 1.668 0 1 0-3.335 0v3.461","key":1})]));
}

Home.defaultProps = {"fill":"none","viewBox":"0 0 14 14","height":"18","width":"18"};

module.exports = Home;

Home.default = Home;
